module.exports = __webpack_public_path__ + "img/電気回路_2_10_3.9c861a8f.png";